import store from '../store/Store';
import getPbpSettingRequestStatus from './getPbpSettingRequestStatus';
import { PublishStatus } from '../store/schema/BookWithMeOrganizerStore';
import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';

/**
 * Selector function gets whether or not we should disable the share buttons
 * Note, this is only for new user scenarios to lower confusion regarding the publishing delay
 */
export default function isShareDisabled(): boolean {
    let shareDisabled = false;
    // If page is published on the attendee side, enable share button
    if (store.masterPublished) {
        return shareDisabled;
    }
    // this check helps us easily turn off disable functionality if there is an imediate present bug
    shareDisabled =
        store.BookingPagePublishedStatus == PublishStatus.Pending ||
        store.BookingPagePublishedStatus == PublishStatus.Publishing ||
        store.BookingPagePublishedStatus == PublishStatus.Incomplete ||
        getPbpSettingRequestStatus() == 4 ||
        getPbpSettingRequestStatus() == 3;

    return shareDisabled;
}
